import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { CurrentStoreContext } from '../../controller/StoreController';
import { AuthContext } from '../../navigation/AuthProvider';
import DropdownSelect from '../../components/DropdownSelect';
import CustomTable from '../../components/Table';
import moment from 'moment-timezone';
import { useToast } from '../../controller/ToastController';
import { getTimeValue, checkBetween } from '../../utils/util';
import HotelController, { PickUpZoneType } from '../../controller/HotelController';

const hourList: any = [];
const minuteList: any = [];
for (let i = 0; i < 24; i++) {
  hourList.push({
    key: i,
    value: i > 9 ? `${i}` : `0${i}`,
    label: i > 9 ? `${i}시` : `0${i}시`,
    name: i > 9 ? `${i}시` : `0${i}시`,
  });
}
for (let i = 0; i < 12; i++) {
  minuteList.push({
    key: i,
    value: i > 1 ? `${i * 5}` : `0${i * 5}`,
    label: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
    name: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}

const HotelPickupSetting = () => {
  const showToast = useToast();

  const [zoneList, setZoneList] = useState<PickUpZoneType[]>([]);
  const [pickupName, setPickupName] = useState<string>('');
  const [pickupNameEn, setPickupNameEn] = useState<string>('');
  const [isAlways, setIsAlways] = useState<boolean>(false);
  const [startHour, setStartHour] = useState<string>('00');
  const [startMin, setStartMin] = useState<string>('00');
  const [endHour, setEndHour] = useState<string>('01');
  const [endMin, setEndMin] = useState<string>('00');
  const [visibleGuide, setVisibleGuide] = useState<boolean>(false);

  const { currentStore } = useOutletContext<CurrentStoreContext>();

  // onChange
  const onChange_pickupName = (event: any) => {
    setPickupName(event.target.value);
  };
  // onChange
  const onChange_pickupNameEn = (event: any) => {
    setPickupNameEn(event.target.value);
  };
  const onChange_StartHour = (e: any) => {
    setStartHour(e.value);
  };
  const onChange_StartMin = (e: any) => {
    setStartMin(e.value);
  };
  const onChange_EndHour = (e: any) => {
    setEndHour(e.value);
  };
  const onChange_EndMin = (e: any) => {
    setEndMin(e.value);
  };

  const addItem = () => {
    const startDate = startHour + ':' + startMin;
    const endDate = endHour + ':' + endMin;

    console.log('date', startDate, endDate);

    let enableAdd = true;
    if (isAlways) {
      if (zoneList.length !== 0) enableAdd = false;
    } else if (startDate === endDate) {
      enableAdd = false;
    } else {
      zoneList.map((item: PickUpZoneType) => {
        if (!checkBetween(item.start_time, item.end_time, startDate, endDate)) {
          enableAdd = false;
        }
      });
    }

    if (pickupName.length > 0) {
      if (enableAdd) {
        zoneList.push({
          pickup_name: pickupName,
          pickup_name_en: pickupNameEn,
          start_time: `${isAlways ? '00:00' : `${startHour}:${startMin}`}` + ':00',
          end_time: `${isAlways ? '23:59' : `${endHour}:${endMin}`}` + ':00',
        });
        showToast('배달장소가 추가되었어요');
      } else {
        showToast('중복되는 시간이 있어요', 'error');
      }
    } else {
      showToast('이름을 입력해주세요', 'error');
    }
  };

  const checkRequired = () => {
    return false;
  };

  // API 호출
  // 픽업존 불러오기
  const getPickupZone = async () => {
    try {
      const oRes: any = await HotelController.getPickUpZone(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log('getPickupZone', oResponse);

        if (oResponse.data) {
          setZoneList([...oResponse.data]);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 픽업존 변경하기
  const setPickupZone = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
        pickup_zone_list: zoneList,
      };
      const oRes: any = await HotelController.setPickUpZone(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log('setPickupZone', oResponse);

        if (oResponse.data) {
          showToast('배달장소를 저장했어요');
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 픽업존 삭제하기
  const delPickupZone = async (index: number) => {
    try {
      const selectedId = zoneList[index].pickup_id;

      if (selectedId) {
        const oParams = {
          store_id: currentStore.value,
          pickup_id: selectedId,
        };
        const oRes: any = await HotelController.delPickUpZone(oParams);

        if (oRes && oRes.data) {
          const oResponse: any = oRes.data;
          console.log('delPickUpZone', oResponse);

          getPickupZone();

          if (oResponse.data) {
            showToast('배달장소를 삭제했어요');
          }
        }
      } else {
        zoneList.splice(index, 1);
        setZoneList([...zoneList]);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getPickupZone();
  }, []);

  const pickupGuide = useMemo(() => {
    return (
      <div className={`guideBox ${visibleGuide && 'active'}`}>
        <h5 className="guideTitle">표시 위치 가이드</h5>
        <h5 className="guideContent">* 고객님께 배달이 도착하면, 기기에 알림이 노출됩니다.</h5>
        <img
          src={`${process.env.PUBLIC_URL}/img/pickupGuide01.png`}
          alt="표시 위치 가이드 이미지"
        />
      </div>
    );
  }, [visibleGuide]);

  const tableHeader = ['순서', '배달장소', '시간', ''];
  const renderTableItem = () => {
    return (
      <>
        {zoneList.map((data: PickUpZoneType, index: number) => (
          <tr key={index} className="webTableWrap">
            <td>{index + 1}</td>
            <td>
              (한국어) {data.pickup_name} / (영어){data.pickup_name_en}
            </td>
            <td>{`${
              data.start_time === '00:00' && data.end_time === '23:59'
                ? '항상'
                : `${data.start_time}-${data.end_time}`
            }`}</td>
            <td>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_trashcan.svg`}
                alt="삭제"
                onClick={() => delPickupZone(index)}
              />
            </td>
          </tr>
        ))}
      </>
    );
  };

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial guide">
              <h4>배달장소 추가</h4>
              <img
                onClick={() => setVisibleGuide(!visibleGuide)}
                src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                alt="가이드 아이콘"
              />
              {visibleGuide && pickupGuide}
            </div>
            <input
              type="text"
              placeholder="배달장소를 입력해주세요"
              value={pickupName}
              onChange={onChange_pickupName}
              autoFocus={true}
            />
            <div className="title bottom">
              <input
                type="text"
                placeholder="(영어)배달장소를 입력해주세요"
                value={pickupNameEn}
                onChange={onChange_pickupNameEn}
                autoFocus={true}
              />
            </div>
          </div>
          <div className="selectWrap">
            <div className="selectDateWrap">
              <div className="dateSelect">
                <DropdownSelect
                  options={hourList}
                  defaultValue={hourList[0]}
                  onChangeValue={onChange_StartHour}
                  disabled={isAlways}
                />
              </div>
              <div className="dateSelect">
                <DropdownSelect
                  options={minuteList}
                  defaultValue={minuteList[0]}
                  onChangeValue={onChange_StartMin}
                  disabled={isAlways}
                />
              </div>
              ~
              <div className="dateSelect">
                <DropdownSelect
                  options={hourList}
                  defaultValue={hourList[1]}
                  onChangeValue={onChange_EndHour}
                  disabled={isAlways}
                />
              </div>
              <div className="dateSelect">
                <DropdownSelect
                  options={minuteList}
                  defaultValue={minuteList[0]}
                  onChangeValue={onChange_EndMin}
                  disabled={isAlways}
                />
              </div>
            </div>
          </div>
          <label>
            <input
              type="checkbox"
              id={`isAlways`}
              autoFocus={false}
              checked={isAlways}
              onChange={() => setIsAlways(!isAlways)}
            />
            <div className={`checkbox ${isAlways && 'active'}`}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_check_white.svg`} alt="체크박스" />
            </div>
            항상
          </label>
          <button className="addButton" onClick={addItem}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가" />
            <h5>배달장소 추가하기</h5>
          </button>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <p>중복되는 시간은 설정할 수 없습니다. </p>
          </div>
        </div>

        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>배달 픽업장소</h4>
            </div>
            <CustomTable
              tableHeader={tableHeader}
              renderTableItem={renderTableItem}
              type="noneborder"
            />
          </div>
          <button className={`submitButton`} onClick={setPickupZone}>
            배달장소 저장
          </button>
        </div>
      </Style>
    </>
  );
};

export default HotelPickupSetting;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  .inputText {
    img {
      cursor: pointer;
    }
    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .greyFont {
        color: #a7a7a7;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
    .title.bottom {
      padding: 12px 0 6px 0;
    }
    .title.guide {
      width: 100%;
      position: relative;
    }

    input,
    textarea {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #cecece;
      border-radius: 5px;
    }

    input::placeholder,
    textarea::placeholder {
      color: #a7a7a7;
    }

    textarea {
      min-height: 120px;
    }
  }

  .infoBadge {
    background: #ecf5f3;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 8px 20px;
    gap: 6px;
    h4 {
      color: #555555;
    }
  }

  .selectWrap {
    width: 100%;
    padding-top: 14px;
  }
  .selectDateWrap {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #979797;

    .dateSelect {
      flex: 1;
    }
  }

  .row {
    gap: 16px;
  }
  input[type='checkbox'] {
    display: none;
  }
  label {
    padding: 10px 0;
    width: min-content;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    gap: 10px;
    color: #979797;
    white-space: nowrap;
  }
  .checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
  }
  .checkbox.active {
    background: #4dd2ae;
    border: 1px solid #4dd2ae;
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    gap: 5%;

    h5 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .nonborder {
    tbody td {
      padding: 12px 0;
      font-size: 14px;
      font-weight: 500;
      color: #555555;
      overflow: hidden;
      white-space: normal;
      text-overflow: ellipsis;
    }
    td:nth-child(1) {
      width: 10%;
    }
  }

  /* guideBox */
  .guideBox {
    position: absolute;
    padding: 10px 25px;
    top: 5px;
    left: 160px;
    background: #edeeee;
    border-radius: 5px;
    z-index: 2;
    box-shadow: 3px 3px 7.5px 0px #0000001a;

    h5.guideTitle {
      line-height: 30px;
      color: #4d4d4d;
      font-weight: 500;
    }
    h5.guideContent {
      color: #a7a7a7;
      font-weight: 500;
    }
    img {
      padding: 10px 60px 10px 0;
    }
  }
  .guideBox.active {
    animation: fadeIn 0.2s ease-in-out forwards;
  }
`;
